// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"BackButton_backButtonContainer__v+QiG","backButton":"BackButton_backButton__SI3qJ"};